/*
 * @Author: yanghailong
 * @Date: 2025-03-27 11:01:30
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-27 11:17:23
 */


/**
 * 创建元素
 * @param {string} tagName 元素标签名
 * @param {[]} [classList] 元素类名
 * @param {object} [attrs] 其他属性对象
 * @returns {HTMLElement}
 */
export function createElement(tagName, classList = [], attrs) {
  let el = document.createElement(tagName)
  for (const className of classList) {
    el.classList.add(className)
  }

  if (attrs != null) {
    for (const key in attrs) {
      if (attrs.hasOwnProperty(key)) {
        el.setAttribute(key, attrs[key])
      }
    }
  }

  return el
}

/**
 * 获取鼠标相对于元素的位置
 * @param {HTMLElement} element
 * @returns {{x:number, y:number}}
 */
export function mouseCapture(element) {
  var mouse = { x: 0, y: 0 }
  element.addEventListener('mousemove', function (event) {
    var x = event.pageX
    var y = event.pageY

    var rect = element.getBoundingClientRect()

    x -= rect.x
    y -= rect.y


    mouse.x = x
    mouse.y = y
  })

  return mouse
}




/**
 * 获取元素相对于父元素的位置
 * @param {HTMLElement} element 元素
 * @param {HTMLElement} parentElement 父元素
 * @returns {{x:number, y:number}}
 */
export function transformToLocal(element, parentElement) {
  let rect = element.getBoundingClientRect()
  let parentRect = parentElement.getBoundingClientRect()
  return {
    x: rect.x - parentRect.x,
    y: rect.y - parentRect.y
  }
}




/**
 * @typedef Rect 矩形
 * @property {number} x
 * @property {number} y
 * @property {number} width
 * @property {number} height
 */

/**
 * 点是否在矩形内
 * @param {Rect} rect
 * @param {number} x
 * @param {number} y
 * @returns {boolean}
 */
export function pointInRect(rect, x, y) {

  return !(
    x < rect.x ||
    x > rect.x + rect.width ||
    y < rect.y ||
    y > rect.y + rect.height
  )
}




/**
 * @typedef Circle 园形
 * @property {number} x
 * @property {number} y
 * @property {number} radius
 */

/**
 * 点是否在圆内
 * @param {Circle} circle
 * @param {number} x
 * @param {number} y
 * @returns {boolean}
 */
export function pointInCircle(circle, x, y) {
  let dx = x - circle.x
  let dy = y - circle.y
  return Math.hypot(dx, dy) < circle.radius
}



/**
 * 获取url中的参数
 * @param {string} name 名称
 * @returns 
 */
export function getHashQuery(name) {
  const search = new URLSearchParams(location.hash.split('?')[1])
  return search.get(name)
}